import { useState, useEffect } from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Font,
  StyleSheet,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";

import * as APIEXPMEDICA from "../../services/expmedica";
import * as APIANALITICA from "../../services/analiticas";

import { FontRegister, DocStyles, LogoTavad } from "./DocStyles";

import { FormatDate } from './FormatDate';

import { useLoaderData, useParams } from "react-router-dom";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

export function InfAltaField({
  updateData,
  autoEspecialistaData,
  autoPacienteData,
  autoTratamientoData,
  savedData,
}) {
  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  const [expMedica, setExpMedica] = useState({});

  let especialistaFullName = autoEspecialistaData
    ? autoEspecialistaData?.first_name + " " + autoEspecialistaData?.last_name
    : undefined;
  let pacienteFullName = autoPacienteData
    ? autoPacienteData?.first_name + " " + autoPacienteData?.last_name
    : undefined;

  const [docResp, setDocResp] = useState(
    savedData?.docResp ? savedData?.docResp : especialistaFullName
  );
  const [docColegiado, setDocColegiado] = useState(
    savedData?.docColegiado
      ? savedData?.docColegiado
      : autoEspecialistaData?.meta?.colegiado
  );
  const [docFecha, setDocFecha] = useState(
    savedData?.docFecha ? savedData?.docFecha : todayDate
  );
  const [docPacie, setDocPacie] = useState(
    savedData?.docPacie ? savedData?.docPacie : pacienteFullName
  );
  const [docNhc, setDocNhc] = useState(
    savedData?.docNhc ? savedData?.docNhc : autoPacienteData?.meta?.hce + "" || ""
  );
  const [docFechIngr, setDocFechIngr] = useState(
    savedData?.docFechIngr ? savedData?.docFechIngr : autoTratamientoData?.meta?.fecha
  );
  const [docMotivIngr, setDocMotivIngr] = useState(
    savedData?.docMotivIngr ? savedData?.docMotivIngr : ""
  );
  const [docObserv, setDocObserv] = useState(
    savedData?.docObserv ? savedData?.docObserv : ""
  );
  const [docEnfAct, setDocEnfAct] = useState(
    savedData?.docEnfAct ? savedData?.docEnfAct : ""
  );
  const [docExplAspect, setDocExplAspect] = useState(
    savedData?.docExplAspect ? savedData?.docExplAspect : expMedica?.meta?.expmedAspgen
  );
  const [docExplPiel, setDocExplPiel] = useState(
    savedData?.docExplPiel ? savedData?.docExplPiel : expMedica?.meta?.expmedPiel
  );
  const [docExplNariz, setDocExplNariz] = useState(
    savedData?.docExplNariz ? savedData?.docExplNariz : expMedica?.meta?.expmedNariz
  );
  const [docExplBoca, setDocExplBoca] = useState(
    savedData?.docExplBoca ? savedData?.docExplBoca : expMedica?.meta?.expmedBoca
  );
  const [docExplOrof, setDocExplOrof] = useState(
    savedData?.docExplOrof ? savedData?.docExplOrof : expMedica?.meta?.expmedOrofar
  );
  const [docExplTronc, setDocExplTronc] = useState(
    savedData?.docExplTronc ? savedData?.docExplTronc : expMedica?.meta?.expmedTronc
  );
  const [docExplExtr, setDocExplExtr] = useState(
    savedData?.docExplExtr ? savedData?.docExplExtr : expMedica?.meta?.expmedExtrem
  );
  const [docExplFane, setDocExplFane] = useState(
    savedData?.docExplFane ? savedData?.docExplFane : expMedica?.meta?.expmedFaner
  );
  const [docExplAusc, setDocExplAusc] = useState(
    savedData?.docExplAusc ? savedData?.docExplAusc : expMedica?.meta?.expmedAusc
  );
  const [docExplVesi, setDocExplVesi] = useState(
    savedData?.docExplVesi ? savedData?.docExplVesi : expMedica?.meta?.expmedMvesic
  );
  const [docExplVent, setDocExplVent] = useState(
    savedData?.docExplVent ? savedData?.docExplVent : expMedica?.meta?.expmedVentbas
  );
  const [docExplTASent, setDocExplTASent] = useState(
    savedData?.docExplTASent ? savedData?.docExplTASent : expMedica?.meta?.expmedTasent
  );
  const [docExplFrecCard, setDocExplFrecCard] = useState(
    savedData?.docExplFrecCard ? savedData?.docExplFrecCard : expMedica?.meta?.expmedFreccard
  );
  const [docExplRitCard, setDocExplRitCard] = useState(
    savedData?.docExplRitCard ? savedData?.docExplRitCard : expMedica?.meta?.expmedRcard
  );
  const [docExplFrecResp, setDocExplFrecResp] = useState(
    savedData?.docExplFrecResp ? savedData?.docExplFrecResp : expMedica?.meta?.expmedFrecresp
  );
  const [docExplElectr, setDocExplElectr] = useState(
    savedData?.docExplElectr ? savedData?.docExplElectr : expMedica?.meta?.expmedElectroc
  );
  const [docExplPulCar, setDocExplPulCar] = useState(
    savedData?.docExplPulCar ? savedData?.docExplPulCar : expMedica?.meta?.expmedPulscarot
  );
  const [docExplPulYug, setDocExplPulYug] = useState(
    savedData?.docExplPulYug ? savedData?.docExplPulYug : expMedica?.meta?.expmedPulyug
  );
  const [docExplLocom, setDocExplLocom] = useState(
    savedData?.docExplLocom ? savedData?.docExplLocom : expMedica?.meta?.expmedLocom
  );
  const [docExplExpRef, setDocExplExpRef] = useState(
    savedData?.docExplExpRef ? savedData?.docExplExpRef : expMedica?.meta?.expmedExplrefl
  );
  const [docExplRefPup, setDocExplRefPup] = useState(
    savedData?.docExplRefPup ? savedData?.docExplRefPup : expMedica?.meta?.expmedReflpup
  );
  const [docExplRefRot, setDocExplRefRot] = useState(
    savedData?.docExplRefRot ? savedData?.docExplRefRot : expMedica?.meta?.expmedRefrot
  );
  const [docDetAnali, setDocDetAnali] = useState(
    savedData?.docDetAnali ? savedData?.docDetAnali : ""
  );
  const [docTestOrina, setDocTestOrina] = useState(
    savedData?.docTestOrina ? savedData?.docTestOrina : ""
  );
  const [docEvoluc, setDocEvoluc] = useState(
    savedData?.docEvoluc ? savedData?.docEvoluc : ""
  );
  const [docJuiClin, setDocJuiClin] = useState(
    savedData?.docJuiClin ? savedData?.docJuiClin : ""
  );
  const [docTratFarm, setDocTratFarm] = useState(
    savedData?.docTratFarm ? savedData?.docTratFarm : ""
  );
  const [docRecomdMed, setDocRecomdMed] = useState(
    savedData?.docRecomdMed
      ? savedData?.docRecomdMed
      : "Acuda a su Médico de Atención Primaria para estudio y tratamiento de ..."
  );

  const [docRecomdIng, setDocRecomdIng] = useState(
    savedData?.docRecomdIng
      ? savedData?.docRecomdIng
      : "Evite la ingesta de vinagres o salsas que contengan alcohol, así como la aplicación cutánea directa de perfumes, hidrogeles, enjuagues bucales y desodorantes que también lo contengan."
  );

  // Datos selector de analiticas:
  const [analiticas, setAnaliticas] = useState([]);
  const [opcionesAnalitica, setOpcionesAnalitica] = useState([]);
  const [docAnalitica, setDocAnalitica] = useState( savedData?.docAnalitica ? savedData?.docAnalitica : "" );

  // Datos Analitica Seleccionada
  const [analitica, setAnalitica] = useState({});
  console.log(analitica);
  const [analiFecha, setAnaliFecha ] = useState(null);
  const [analiExist, setAnaliExist ] = useState(false);
  const [analiCompleta, setAnaliCompleta ] = useState(null);

  const [analiHematiesResult, setAnaliHematiesResult] = useState(null);
  const [analiHemoglobResult, setAnaliHemoglobResult] = useState(null);
  const [analiHematcrResult, setAnaliHematcrResult] = useState(null);
  const [analiVcmResult, setAnaliVcmResult] = useState(null);
  const [analiHcmResult, setAnaliHcmResult] = useState(null);
  const [analiChcmResult, setAnaliChcmResult] = useState(null);
  const [analiIdhResult, setAnaliIdhResult] = useState(null);
  const [analiLeucoResult, setAnaliLeucoResult] = useState(null);
  const [analiNeutrResult, setAnaliNeutrResult] = useState(null);
  const [analiLinfoResult, setAnaliLinfoResult] = useState(null);
  const [analiMonocResult, setAnaliMonocResult] = useState(null);
  const [analiEosinResult, setAnaliEosinResult] = useState(null);
  const [analiBasofResult, setAnaliBasofResult] = useState(null);
  const [analiPlaqResult, setAnaliPlaqResult] = useState(null);
  const [analiPctResult, setAnaliPctResult] = useState(null);
  const [analiVpmResult, setAnaliVpmResult] = useState(null);
  const [analiIdpResult, setAnaliIdpResult] = useState(null);
  const [analiTieProtResult, setAnaliTieProtResult] = useState(null);
  const [analiActProtResult, setAnaliActProtResult] = useState(null);
  const [analiInrResult, setAnaliInrResult] = useState(null);
  const [analiGlucResult, setAnaliGlucResult] = useState(null);
  const [analiUreaResult, setAnaliUreaResult] = useState(null);
  const [analiCreatResult, setAnaliCreatResult] = useState(null);
  const [analiGlomResult, setAnaliGlomResult] = useState(null);
  const [analiAsparResult, setAnaliAsparResult] = useState(null);
  const [analiAlanResult, setAnaliAlanResult] = useState(null);
  const [analiGammResult, setAnaliGammResult] = useState(null);
  const [analiFosfResult, setAnaliFosfResult] = useState(null);
  const [analiBiliResult, setAnaliBiliResult] = useState(null);
  const [analiColestResult, setAnaliColestResult] = useState(null);
  const [analiColestHdlResult, setAnaliColestHdlResult] = useState(null);
  const [analiColestLdlResult, setAnaliColestLdlResult] = useState(null);
  const [analiTriglResult, setAnaliTriglResult] = useState(null);
  const [analiCalcResult, setAnaliCalcResult] = useState(null);
  const [analiHierrResult, setAnaliHierrResult] = useState(null);
  const [analiSodResult, setAnaliSodResult] = useState(null);
  const [analiPotasResult, setAnaliPotasResult] = useState(null);
  const [analiVitbResult, setAnaliVitbResult] = useState(null);
  const [analiVitohResult, setAnaliVitohResult] = useState(null);
  const [analiAcidfolResult, setAnaliAcidfolResult] = useState(null);
  const [analiMagnResult, setAnaliMagnResult] = useState(null);
  const [analiFerriResult, setAnaliFerriResult] = useState(null);
  const [analiProtcResult, setAnaliProtcResult] = useState(null);

  // Analitica Limits
  const [analiHematiesLow, setAnaliHematiesLow ] = useState(null);
  const [analiHematiesHigh, setAnaliHematiesHigh ] = useState(null);
  const [analiHemoglobLow, setAnaliHemoglobLow ] = useState(null);
  const [analiHemoglobHigh, setAnaliHemoglobHigh ] = useState(null);
  const [analiHematcrLow, setAnaliHematcrLow ] = useState(null);
  const [analiHematcrHigh, setAnaliHematcrHigh ] = useState(null);
  const [analiVcmLow, setAnaliVcmLow ] = useState(null);
  const [analiVcmHigh, setAnaliVcmHigh ] = useState(null);
  const [analiHcmLow, setAnaliHcmLow ] = useState(null);
  const [analiHcmHigh, setAnaliHcmHigh ] = useState(null);
  const [analiChcmLow, setAnaliChcmLow ] = useState(null);
  const [analiChcmHigh, setAnaliChcmHigh ] = useState(null);
  const [analiIdhLow, setAnaliIdhLow ] = useState(null);
  const [analiIdhHigh, setAnaliIdhHigh ] = useState(null);
  const [analiLeucoLow, setAnaliLeucoLow ] = useState(null);
  const [analiLeucoHigh, setAnaliLeucoHigh ] = useState(null);
  const [analiNeutrLow, setAnaliNeutrLow ] = useState(null);
  const [analiNeutrHigh, setAnaliNeutrHigh ] = useState(null);
  const [analiLinfoLow, setAnaliLinfoLow ] = useState(null);
  const [analiLinfoHigh, setAnaliLinfoHigh ] = useState(null);
  const [analiMonocLow, setAnaliMonocLow ] = useState(null);
  const [analiMonocHigh, setAnaliMonocHigh ] = useState(null);
  const [analiEosinLow, setAnaliEosinLow ] = useState(null);
  const [analiEosinHigh, setAnaliEosinHigh ] = useState(null);
  const [analiBasofLow, setAnaliBasofLow ] = useState(null);
  const [analiBasofHigh, setAnaliBasofHigh ] = useState(null);
  const [analiPlaqLow, setAnaliPlaqLow ] = useState(null);
  const [analiPlaqHigh, setAnaliPlaqHigh ] = useState(null);
  const [analiPctLow, setAnaliPctLow ] = useState(null);
  const [analiPctHigh, setAnaliPctHigh ] = useState(null);
  const [analiVpmLow, setAnaliVpmLow ] = useState(null);
  const [analiVpmHigh, setAnaliVpmHigh ] = useState(null);
  const [analiIdpLow, setAnaliIdpLow ] = useState(null);
  const [analiIdpHigh, setAnaliIdpHigh ] = useState(null);
  const [analiTieProtLow, setAnaliTieProtLow ] = useState(null);
  const [analiTieProtHigh, setAnaliTieProtHigh ] = useState(null);
  const [analiActProtLow, setAnaliActProtLow ] = useState(null);
  const [analiActProtHigh, setAnaliActProtHigh ] = useState(null);
  const [analiInrLow, setAnaliInrLow ] = useState(null);
  const [analiInrHigh, setAnaliInrHigh ] = useState(null);
  const [analiGlucLow, setAnaliGlucLow ] = useState(null);
  const [analiGlucHigh, setAnaliGlucHigh ] = useState(null);
  const [analiUreaLow, setAnaliUreaLow ] = useState(null);
  const [analiUreaHigh, setAnaliUreaHigh ] = useState(null);
  const [analiCreatLow, setAnaliCreatLow ] = useState(null);
  const [analiCreatHigh, setAnaliCreatHigh ] = useState(null);
  const [analiGlomLow, setAnaliGlomLow ] = useState(null);
  const [analiGlomHigh, setAnaliGlomHigh ] = useState(null);
  const [analiAsparLow, setAnaliAsparLow ] = useState(null);
  const [analiAsparHigh, setAnaliAsparHigh ] = useState(null);
  const [analiAlanLow, setAnaliAlanLow ] = useState(null);
  const [analiAlanHigh, setAnaliAlanHigh ] = useState(null);
  const [analiGammLow, setAnaliGammLow ] = useState(null);
  const [analiGammHigh, setAnaliGammHigh ] = useState(null);
  const [analiFosfLow, setAnaliFosfLow ] = useState(null);
  const [analiFosfHigh, setAnaliFosfHigh ] = useState(null);
  const [analiBiliLow, setAnaliBiliLow ] = useState(null);
  const [analiBiliHigh, setAnaliBiliHigh ] = useState(null);
  const [analiColestLow, setAnaliColestLow ] = useState(null);
  const [analiColestHigh, setAnaliColestHigh ] = useState(null);
  const [analiColestHdlLow, setAnaliColestHdlLow ] = useState(null);
  const [analiColestHdlHigh, setAnaliColestHdlHigh ] = useState(null);
  const [analiColestLdlLow, setAnaliColestLdlLow ] = useState(null);
  const [analiColestLdlHigh, setAnaliColestLdlHigh ] = useState(null);
  const [analiTriglLow, setAnaliTriglLow ] = useState(null);
  const [analiTriglHigh, setAnaliTriglHigh ] = useState(null);
  const [analiCalcLow, setAnaliCalcLow ] = useState(null);
  const [analiCalcHigh, setAnaliCalcHigh ] = useState(null);
  const [analiHierrLow, setAnaliHierrLow ] = useState(null);
  const [analiHierrHigh, setAnaliHierrHigh ] = useState(null);
  const [analiSodLow, setAnaliSodLow ] = useState(null);
  const [analiSodHigh, setAnaliSodHigh ] = useState(null);
  const [analiPotasLow, setAnaliPotasLow ] = useState(null);
  const [analiPotasHigh, setAnaliPotasHigh ] = useState(null);
  const [analiVitbLow, setAnaliVitbLow ] = useState(null);
  const [analiVitbHigh, setAnaliVitbHigh ] = useState(null);
  const [analiVitohLow, setAnaliVitohLow ] = useState(null);
  const [analiVitohHigh, setAnaliVitohHigh ] = useState(null);
  const [analiAcidfolLow, setAnaliAcidfolLow ] = useState(null);
  const [analiAcidfolHigh, setAnaliAcidfolHigh ] = useState(null);
  const [analiMagnLow, setAnaliMagnLow ] = useState(null);
  const [analiMagnHigh, setAnaliMagnHigh ] = useState(null);
  const [analiFerriLow, setAnaliFerriLow ] = useState(null);
  const [analiFerriHigh, setAnaliFerriHigh ] = useState(null);
  const [analiProtcLow, setAnaliProtcLow ] = useState(null);
  const [analiProtcHigh, setAnaliProtcHigh ] = useState(null);

  // Load All analiticas and create a select options with date as selector and id as value
  useEffect(() => {
    const loadAnaliticas = async () => {
      if (autoTratamientoData?.id) {
        const allAnaliticas = await APIANALITICA.getAllAnaliticasByTax(autoTratamientoData?.id);
        console.log(allAnaliticas)
        if (allAnaliticas.length > 0) {
          setAnaliticas(allAnaliticas);
          // Si hay analíticas, mapearlas para crear las opciones del select
          const opciones = allAnaliticas.map(analitica => (
            <option key={analitica.id} value={analitica.id}>{FormatDate(analitica?.meta?.analiFechaAnali)}</option>
          ));
          // Agregar la opción "Selecciona una opción" al inicio del array de opciones
          opciones.unshift(<option key="selecciona-opcion" disabled value=''>-- Selecciona una opción --</option>);
          // Actualizar el estado con las opciones generadas
          setOpcionesAnalitica(opciones);
        } else {
          // Si no hay analíticas, mostrar opción "Sin analíticas" y deshabilitada
          setOpcionesAnalitica([<option key="sin-analiticas" disabled value=''>-- Sin analíticas --</option>]);
        }
      }
    };

    loadAnaliticas();
  }, [autoTratamientoData]);

  // Load selected analitica
  useEffect(() => {
    console.log("ejecutando use effect", docAnalitica)
    let selectedAnalitica = null;
    // Recorrer el array de analiticas
    for (const analitica of analiticas) {
      console.log("dentro del for", analitica)
      // Verificar si el ID de la analítica actual coincide con docAnalitica
      if (analitica.id == docAnalitica) {
        // Asignar la analítica seleccionada
        selectedAnalitica = analitica;
        break; // Terminar el bucle una vez que se haya encontrado la analítica deseada
      }
    }
    setAnalitica(selectedAnalitica);
  }, [docAnalitica, analiticas]);

  // useEffect(() => {
	// 	const loadAnalitica = async () => {
  //     if (docAnalitica) {
	// 		const analitica = await APIANALITICA.getAnaliticasByID(docAnalitica);

	// 		// After fetching data stored it in posts state.
	// 		setAnalitica(analitica);
  //     }

	// 	}

	// 	// Call the function
	// 	loadAnalitica();
	// }, [docAnalitica]);

  // Load analitica Meta
  useEffect(() => {
		const loadAnaliticaMeta = async () => {

      if (analitica && Object.keys(analitica).length > 0 && typeof analitica === 'object') {
        setAnaliFecha(FormatDate(analitica?.meta?.analiFechaAnali));
        setAnaliHematiesResult(analitica?.meta?.analiHematiesResult);
        setAnaliHemoglobResult(analitica?.meta?.analiHemoglobResult);
        setAnaliHematcrResult(analitica?.meta?.analiHematcrResult);
        setAnaliVcmResult(analitica?.meta?.analiVcmResult);
        setAnaliHcmResult(analitica?.meta?.analiHcmResult);
        setAnaliChcmResult(analitica?.meta?.analiChcmResult);
        setAnaliIdhResult(analitica?.meta?.analiIdhResult);
        setAnaliLeucoResult(analitica?.meta?.analiLeucoResult);
        setAnaliNeutrResult(analitica?.meta?.analiNeutrResult);
        setAnaliLinfoResult(analitica?.meta?.analiLinfoResult);
        setAnaliMonocResult(analitica?.meta?.analiMonocResult);
        setAnaliEosinResult(analitica?.meta?.analiEosinResult);
        setAnaliBasofResult(analitica?.meta?.analiBasofResult);
        setAnaliPlaqResult(analitica?.meta?.analiPlaqResult);
        setAnaliPctResult(analitica?.meta?.analiPctResult);
        setAnaliVpmResult(analitica?.meta?.analiVpmResult);
        setAnaliIdpResult(analitica?.meta?.analiIdpResult);
        setAnaliTieProtResult(analitica?.meta?.analiTieProtResult);
        setAnaliActProtResult(analitica?.meta?.analiActProtResult);
        setAnaliInrResult(analitica?.meta?.analiInrResult);
        setAnaliGlucResult(analitica?.meta?.analiGlucResult);
        setAnaliUreaResult(analitica?.meta?.analiUreaResult);
        setAnaliCreatResult(analitica?.meta?.analiCreatResult);
        setAnaliGlomResult(analitica?.meta?.analiGlomResult);
        setAnaliAsparResult(analitica?.meta?.analiAsparResult);
        setAnaliAlanResult(analitica?.meta?.analiAlanResult);
        setAnaliGammResult(analitica?.meta?.analiGammResult);
        setAnaliFosfResult(analitica?.meta?.analiFosfResult);
        setAnaliBiliResult(analitica?.meta?.analiBiliResult);
        setAnaliColestResult(analitica?.meta?.analiColestResult);
        setAnaliColestHdlResult(analitica?.meta?.analiColestHdlResult);
        setAnaliColestLdlResult(analitica?.meta?.analiColestLdlResult);
        setAnaliTriglResult(analitica?.meta?.analiTriglResult);
        setAnaliCalcResult(analitica?.meta?.analiCalcResult);
        setAnaliHierrResult(analitica?.meta?.analiHierrResult);
        setAnaliSodResult(analitica?.meta?.analiSodResult);
        setAnaliPotasResult(analitica?.meta?.analiPotasResult);
        setAnaliVitbResult(analitica?.meta?.analiVitbResult);
        setAnaliVitohResult(analitica?.meta?.analiVitohResult);
        setAnaliAcidfolResult(analitica?.meta?.analiAcidfolResult);
        setAnaliMagnResult(analitica?.meta?.analiMagnResult);
        setAnaliFerriResult(analitica?.meta?.analiFerriResult);
        setAnaliProtcResult(analitica?.meta?.analiProtcResult);
        setAnaliHematiesLow(analitica?.meta?.analiHematiesLow);
        setAnaliHematiesHigh(analitica?.meta?.analiHematiesHigh);
        setAnaliHemoglobLow(analitica?.meta?.analiHemoglobLow);
        setAnaliHemoglobHigh(analitica?.meta?.analiHemoglobHigh);
        setAnaliHematcrLow(analitica?.meta?.analiHematcrLow);
        setAnaliHematcrHigh(analitica?.meta?.analiHematcrHigh);
        setAnaliVcmLow(analitica?.meta?.analiVcmLow);
        setAnaliVcmHigh(analitica?.meta?.analiVcmHigh);
        setAnaliHcmLow(analitica?.meta?.analiHcmLow);
        setAnaliHcmHigh(analitica?.meta?.analiHcmHigh);
        setAnaliChcmLow(analitica?.meta?.analiChcmLow);
        setAnaliChcmHigh(analitica?.meta?.analiChcmHigh);
        setAnaliIdhLow(analitica?.meta?.analiIdhLow);
        setAnaliIdhHigh(analitica?.meta?.analiIdhHigh);
        setAnaliLeucoLow(analitica?.meta?.analiLeucoLow);
        setAnaliLeucoHigh(analitica?.meta?.analiLeucoHigh);
        setAnaliNeutrLow(analitica?.meta?.analiNeutrLow);
        setAnaliNeutrHigh(analitica?.meta?.analiNeutrHigh);
        setAnaliLinfoLow(analitica?.meta?.analiLinfoLow);
        setAnaliLinfoHigh(analitica?.meta?.analiLinfoHigh);
        setAnaliMonocLow(analitica?.meta?.analiMonocLow);
        setAnaliMonocHigh(analitica?.meta?.analiMonocHigh);
        setAnaliEosinLow(analitica?.meta?.analiEosinLow);
        setAnaliEosinHigh(analitica?.meta?.analiEosinHigh);
        setAnaliBasofLow(analitica?.meta?.analiBasofLow);
        setAnaliBasofHigh(analitica?.meta?.analiBasofHigh);
        setAnaliPlaqLow(analitica?.meta?.analiPlaqLow);
        setAnaliPlaqHigh(analitica?.meta?.analiPlaqHigh);
        setAnaliPctLow(analitica?.meta?.analiPctLow);
        setAnaliPctHigh(analitica?.meta?.analiPctHigh);
        setAnaliVpmLow(analitica?.meta?.analiVpmLow);
        setAnaliVpmHigh(analitica?.meta?.analiVpmHigh);
        setAnaliIdpLow(analitica?.meta?.analiIdpLow);
        setAnaliIdpHigh(analitica?.meta?.analiIdpHigh);
        setAnaliTieProtLow(analitica?.meta?.analiTieProtLow);
        setAnaliTieProtHigh(analitica?.meta?.analiTieProtHigh);
        setAnaliActProtLow(analitica?.meta?.analiActProtLow);
        setAnaliActProtHigh(analitica?.meta?.analiActProtHigh);
        setAnaliInrLow(analitica?.meta?.analiInrLow);
        setAnaliInrHigh(analitica?.meta?.analiInrHigh);
        setAnaliGlucLow(analitica?.meta?.analiGlucLow);
        setAnaliGlucHigh(analitica?.meta?.analiGlucHigh);
        setAnaliUreaLow(analitica?.meta?.analiUreaLow);
        setAnaliUreaHigh(analitica?.meta?.analiUreaHigh);
        setAnaliCreatLow(analitica?.meta?.analiCreatLow);
        setAnaliCreatHigh(analitica?.meta?.analiCreatHigh);
        setAnaliGlomLow(analitica?.meta?.analiGlomLow);
        setAnaliGlomHigh(analitica?.meta?.analiGlomHigh);
        setAnaliAsparLow(analitica?.meta?.analiAsparLow);
        setAnaliAsparHigh(analitica?.meta?.analiAsparHigh);
        setAnaliAlanLow(analitica?.meta?.analiAlanLow);
        setAnaliAlanHigh(analitica?.meta?.analiAlanHigh);
        setAnaliGammLow(analitica?.meta?.analiGammLow);
        setAnaliGammHigh(analitica?.meta?.analiGammHigh);
        setAnaliFosfLow(analitica?.meta?.analiFosfLow);
        setAnaliFosfHigh(analitica?.meta?.analiFosfHigh);
        setAnaliBiliLow(analitica?.meta?.analiBiliLow);
        setAnaliBiliHigh(analitica?.meta?.analiBiliHigh);
        setAnaliColestLow(analitica?.meta?.analiColestLow);
        setAnaliColestHigh(analitica?.meta?.analiColestHigh);
        setAnaliColestHdlLow(analitica?.meta?.analiColestHdlLow);
        setAnaliColestHdlHigh(analitica?.meta?.analiColestHdlHigh);
        setAnaliColestLdlLow(analitica?.meta?.analiColestLdlLow);
        setAnaliColestLdlHigh(analitica?.meta?.analiColestLdlHigh);
        setAnaliTriglLow(analitica?.meta?.analiTriglLow);
        setAnaliTriglHigh(analitica?.meta?.analiTriglHigh);
        setAnaliCalcLow(analitica?.meta?.analiCalcLow);
        setAnaliCalcHigh(analitica?.meta?.analiCalcHigh);
        setAnaliHierrLow(analitica?.meta?.analiHierrLow);
        setAnaliHierrHigh(analitica?.meta?.analiHierrHigh);
        setAnaliSodLow(analitica?.meta?.analiSodLow);
        setAnaliSodHigh(analitica?.meta?.analiSodHigh);
        setAnaliPotasLow(analitica?.meta?.analiPotasLow);
        setAnaliPotasHigh(analitica?.meta?.analiPotasHigh);
        setAnaliVitbLow(analitica?.meta?.analiVitbLow);
        setAnaliVitbHigh(analitica?.meta?.analiVitbHigh);
        setAnaliVitohLow(analitica?.meta?.analiVitohLow);
        setAnaliVitohHigh(analitica?.meta?.analiVitohHigh);
        setAnaliAcidfolLow(analitica?.meta?.analiAcidfolLow);
        setAnaliAcidfolHigh(analitica?.meta?.analiAcidfolHigh);
        setAnaliMagnLow(analitica?.meta?.analiMagnLow);
        setAnaliMagnHigh(analitica?.meta?.analiMagnHigh);
        setAnaliFerriLow(analitica?.meta?.analiFerriLow);
        setAnaliFerriHigh(analitica?.meta?.analiFerriHigh);
        setAnaliProtcLow(analitica?.meta?.analiProtcLow);
        setAnaliProtcHigh(analitica?.meta?.analiProtcHigh);
        if (analitica.meta?.analiticaJson) {
          setAnaliCompleta(JSON.parse(analitica.meta.analiticaJson));
        }
        setAnaliExist(true);
      }

		}
		// Call the function
		loadAnaliticaMeta();
	}, [analitica]);

  // Load analitica Limits
  useEffect(() => {
		const loadAnaliticaLimits = async () => {

      if (analiCompleta) {
        setAnaliHematiesLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_12?.limits2?.L?.toFixed(2));
        setAnaliHematiesHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_12?.limits2?.H?.toFixed(2));
        setAnaliHemoglobLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_13?.limits2?.L?.toFixed(2));
        setAnaliHemoglobHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_13?.limits2?.H?.toFixed(2));
        setAnaliHematcrLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_14?.limits2?.L?.toFixed(2));
        setAnaliHematcrHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_14?.limits2?.H?.toFixed(2));
        setAnaliVcmLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_15?.limits2?.L?.toFixed(2));
        setAnaliVcmHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_15?.limits2?.H?.toFixed(2));
        setAnaliHcmLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_16?.limits2?.L?.toFixed(2));
        setAnaliHcmHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_16?.limits2?.H?.toFixed(2));
        setAnaliChcmLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_17?.limits2?.L?.toFixed(2));
        setAnaliChcmHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_17?.limits2?.H?.toFixed(2));
        setAnaliIdhLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_20?.limits2?.L?.toFixed(2));
        setAnaliIdhHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_20?.limits2?.H?.toFixed(2));
        setAnaliLeucoLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_18?.limits2?.L?.toFixed(2));
        setAnaliLeucoHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_18?.limits2?.H?.toFixed(2));
        setAnaliNeutrLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_38?.limits2?.L?.toFixed(2));
        setAnaliNeutrHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_38?.limits2?.H?.toFixed(2));
        setAnaliLinfoLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_40?.limits2?.L?.toFixed(2));
        setAnaliLinfoHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_40?.limits2?.H?.toFixed(2));
        setAnaliMonocLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_41?.limits2?.L?.toFixed(2));
        setAnaliMonocHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_41?.limits2?.H?.toFixed(2));
        setAnaliEosinLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_31?.limits2?.L?.toFixed(2));
        setAnaliEosinHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_31?.limits2?.H?.toFixed(2));
        setAnaliBasofLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_33?.limits2?.L?.toFixed(2));
        setAnaliBasofHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_33?.limits2?.H?.toFixed(2));
        setAnaliPlaqLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_19?.limits2?.L?.toFixed(2));
        setAnaliPlaqHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_19?.limits2?.H?.toFixed(2));
        setAnaliPctLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_22?.limits2?.L?.toFixed(2));
        setAnaliPctHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_22?.limits2?.H?.toFixed(2));
        setAnaliVpmLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_30?.limits2?.L?.toFixed(2));
        setAnaliVpmHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_30?.limits2?.H?.toFixed(2));
        setAnaliIdpLow(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_23?.limits2?.L?.toFixed(2));
        setAnaliIdpHigh(analiCompleta?.results?.GEN?.HEM?.["TK:HEMO"]?.data?.A_23?.limits2?.H?.toFixed(2));
        setAnaliTieProtLow(analiCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_176?.limits2?.L?.toFixed(2));
        setAnaliTieProtHigh(analiCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_176?.limits2?.H?.toFixed(2));
        setAnaliActProtLow(analiCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_177?.limits2?.L?.toFixed(2));
        setAnaliActProtHigh(analiCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_177?.limits2?.H?.toFixed(2));
        setAnaliInrLow(analiCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_179?.limits2?.L?.toFixed(2));
        setAnaliInrHigh(analiCompleta?.results?.GEN?.COAG?.["TK:A_174"]?.data?.A_179?.limits2?.H?.toFixed(2));
        setAnaliGlucLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_384"]?.limits2?.L?.toFixed(2));
        setAnaliGlucHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_384"]?.limits2?.H?.toFixed(2));
        setAnaliUreaLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_436"]?.limits2?.L?.toFixed(2));
        setAnaliUreaHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_436"]?.limits2?.H?.toFixed(2));
        setAnaliCreatLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_437"]?.limits2?.L?.toFixed(2));
        setAnaliCreatHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_437"]?.limits2?.H?.toFixed(2));
        setAnaliGlomLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_118276"]?.limits2?.L?.toFixed(2));
        setAnaliGlomHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_118276"]?.limits2?.H?.toFixed(2));
        setAnaliAsparLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_498"]?.limits2?.L?.toFixed(2));
        setAnaliAsparHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_498"]?.limits2?.H?.toFixed(2));
        setAnaliAlanLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_499"]?.limits2?.L?.toFixed(2));
        setAnaliAlanHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_499"]?.limits2?.H?.toFixed(2));
        setAnaliGammLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_500"]?.limits2?.L?.toFixed(2));
        setAnaliGammHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_500"]?.limits2?.H?.toFixed(2));
        setAnaliFosfLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_501"]?.limits2?.L?.toFixed(2));
        setAnaliFosfHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_501"]?.limits2?.H?.toFixed(2));
        setAnaliBiliLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_549"]?.limits2?.L?.toFixed(2));
        setAnaliBiliHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_549"]?.limits2?.H?.toFixed(2));
        setAnaliColestLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_556"]?.limits2?.L?.toFixed(2));
        setAnaliColestHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_556"]?.limits2?.H?.toFixed(2));
        setAnaliColestHdlLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_557"]?.limits2?.L?.toFixed(2));
        setAnaliColestHdlHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_557"]?.limits2?.H?.toFixed(2));
        setAnaliColestLdlLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_574"]?.limits2?.L?.toFixed(2));
        setAnaliColestLdlHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_574"]?.limits2?.H?.toFixed(2));
        setAnaliTriglLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_564"]?.limits2?.L?.toFixed(2));
        setAnaliTriglHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_564"]?.limits2?.H?.toFixed(2));
        setAnaliCalcLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_467"]?.limits2?.L?.toFixed(2));
        setAnaliCalcHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_467"]?.limits2?.H?.toFixed(2));
        setAnaliHierrLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_596"]?.limits2?.L?.toFixed(2));
        setAnaliHierrHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_596"]?.limits2?.H?.toFixed(2));
        setAnaliSodLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_613"]?.limits2?.L?.toFixed(2));
        setAnaliSodHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_613"]?.limits2?.H?.toFixed(2));
        setAnaliPotasLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_614"]?.limits2?.L?.toFixed(2));
        setAnaliPotasHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_614"]?.limits2?.H?.toFixed(2));
        setAnaliVitbLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_894"]?.limits2?.L?.toFixed(2));
        setAnaliVitbHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_894"]?.limits2?.H?.toFixed(2));
        setAnaliVitohLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_902"]?.limits2?.L?.toFixed(2));
        setAnaliVitohHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_902"]?.limits2?.H?.toFixed(2));
        setAnaliAcidfolLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_890"]?.limits2?.L?.toFixed(2));
        setAnaliAcidfolHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_890"]?.limits2?.H?.toFixed(2));
        setAnaliMagnLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_1284"]?.limits2?.L?.toFixed(2));
        setAnaliMagnHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_1284"]?.limits2?.H?.toFixed(2));
        setAnaliFerriLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_1042"]?.limits2?.L?.toFixed(2));
        setAnaliFerriHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_1042"]?.limits2?.H?.toFixed(2));
        setAnaliProtcLow(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_764"]?.limits2?.L?.toFixed(2));
        setAnaliProtcHigh(analiCompleta?.results?.GEN?.BIOQ?.["TK:A_764"]?.limits2?.H?.toFixed(2));
      }

		}
		// Call the function
		loadAnaliticaLimits();
	}, [analiCompleta]);


	useEffect(() => {
		const loadExpMedica = async () => {
      if(autoTratamientoData?.id) {
			const expMedica = await APIEXPMEDICA.getAllExpmedicaByTax(autoTratamientoData?.id);

			// After fetching data stored it in posts state.
			setExpMedica(expMedica[expMedica.length - 1]);

		  }
    }

		// Call the function
		loadExpMedica();
  
	}, [autoTratamientoData]);

  useEffect(() => {
		const loadExpMedicaMeta = async () => {

      if (expMedica && Object.keys(expMedica).length > 0 && typeof expMedica === 'object') {
        setDocExplAspect( savedData?.docExplAspect ? savedData?.docExplAspect : expMedica.meta?.expmedAspgen);
        setDocExplPiel( savedData?.docExplPiel ? savedData?.docExplPiel : expMedica.meta?.expmedPiel);
        setDocExplNariz( savedData?.docExplNariz ? savedData?.docExplNariz : expMedica.meta?.expmedNariz);
        setDocExplBoca( savedData?.docExplBoca ? savedData?.docExplBoca : expMedica.meta?.expmedBoca);
        setDocExplOrof( savedData?.docExplOrof ? savedData?.docExplOrof : expMedica.meta?.expmedOrofar);
        setDocExplTronc( savedData?.docExplTronc ? savedData?.docExplTronc : expMedica.meta?.expmedTronc);
        setDocExplExtr( savedData?.docExplExtr ? savedData?.docExplExtr : expMedica.meta?.expmedExtrem);
        setDocExplFane( savedData?.docExplFane ? savedData?.docExplFane : expMedica.meta?.expmedFaner);
        setDocExplAusc( savedData?.docExplAusc ? savedData?.docExplAusc : expMedica.meta?.expmedAusc);
        setDocExplVesi( savedData?.docExplVesi ? savedData?.docExplVesi : expMedica.meta?.expmedMvesic);
        setDocExplVent( savedData?.docExplVent ? savedData?.docExplVent : expMedica.meta?.expmedVentbas);
        setDocExplTASent( savedData?.docExplTASent ? savedData?.docExplTASent : expMedica.meta?.expmedTasent);
        setDocExplFrecCard( savedData?.docExplFrecCard ? savedData?.docExplFrecCard : expMedica.meta?.expmedFreccard);
        setDocExplRitCard( savedData?.docExplRitCard ? savedData?.docExplRitCard : expMedica.meta?.expmedRcard);
        setDocExplFrecResp( savedData?.docExplFrecResp ? savedData?.docExplFrecResp : expMedica.meta?.expmedFrecresp);
        setDocExplElectr( savedData?.docExplElectr ? savedData?.docExplElectr : expMedica.meta?.expmedElectroc);
        setDocExplPulCar( savedData?.docExplPulCar ? savedData?.docExplPulCar : expMedica.meta?.expmedPulscarot);
        setDocExplPulYug( savedData?.docExplPulYug ? savedData?.docExplPulYug : expMedica.meta?.expmedPulyug);
        setDocExplLocom( savedData?.docExplLocom ? savedData?.docExplLocom : expMedica.meta?.expmedLocom);
        setDocExplExpRef( savedData?.docExplExpRef ? savedData?.docExplExpRef : expMedica.meta?.expmedExplrefl);
        setDocExplRefPup( savedData?.docExplRefPup ? savedData?.docExplRefPup : expMedica.meta?.expmedReflpup);
        setDocExplRefRot( savedData?.docExplRefRot ? savedData?.docExplRefRot : expMedica.meta?.expmedRefrot);
      }

		}

		// Call the function
		loadExpMedicaMeta();
	}, [expMedica]);

  let data = {
    docResp,
    docColegiado,
    docFecha,
    docPacie,
    docNhc,
    docFechIngr,
    docMotivIngr,
    docObserv,
    docEnfAct,
    docExplAspect,
    docExplPiel,
    docExplNariz,
    docExplBoca,
    docExplOrof,
    docExplTronc,
    docExplExtr,
    docExplFane,
    docExplAusc,
    docExplVesi,
    docExplVent,
    docExplTASent,
    docExplFrecCard,
    docExplRitCard,
    docExplFrecResp,
    docExplElectr,
    docExplPulCar,
    docExplPulYug,
    docExplLocom,
    docExplExpRef,
    docExplRefPup,
    docExplRefRot,
    docDetAnali,
    docTestOrina,
    docEvoluc,
    docJuiClin,
    docTratFarm,
    docRecomdMed,
    docRecomdIng,
    docAnalitica
  };

  useEffect(() => {
    updateData(data);
  }, [
    docResp,
    docColegiado,
    docFecha,
    docPacie,
    docNhc,
    docFechIngr,
    docMotivIngr,
    docObserv,
    docEnfAct,
    docExplAspect,
    docExplPiel,
    docExplNariz,
    docExplBoca,
    docExplOrof,
    docExplTronc,
    docExplExtr,
    docExplFane,
    docExplAusc,
    docExplVesi,
    docExplVent,
    docExplTASent,
    docExplFrecCard,
    docExplRitCard,
    docExplFrecResp,
    docExplElectr,
    docExplPulCar,
    docExplPulYug,
    docExplLocom,
    docExplExpRef,
    docExplRefPup,
    docExplRefRot,
    docDetAnali,
    docTestOrina,
    docEvoluc,
    docJuiClin,
    docTratFarm,
    docRecomdMed,
    docRecomdIng,
    docAnalitica
  ]);

  // Data for docx generator
  const [showDocxLink, setShowDocxLink] = useState(false);

  const generateDocx = async () => {
    try {
      const response = await fetch(
        "https://app.tavad.com/documentacion-templates/InfAlta.docx"
        // "https://silocreativo.win/docx/InfAlta.docx"
      );
      const blob = await response.blob();
      const arrayBuffer = await new Response(blob).arrayBuffer();

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        nullGetter() {
          return "XXXXXXXXX";
        },
      });

      doc.setData({
        date: FormatDate(docFecha),
        responsable: docResp,
        colegiado: docColegiado,
        paciente: docPacie,
        nhc: docNhc,
        fechaIngreso: FormatDate(docFechIngr),
        motivIngreso: docMotivIngr,
        observ: docObserv,
        enfAct: docEnfAct,
        explAspect: docExplAspect,
        explPiel: docExplPiel,
        explNariz: docExplNariz,
        explBoca: docExplBoca,
        explOrof: docExplOrof,
        explTronc: docExplTronc,
        explExtr: docExplExtr,
        explFane: docExplFane,
        explAusc: docExplAusc,
        explVesi: docExplVesi,
        explVent: docExplVent,
        explTASent: docExplTASent,
        explFrecCard: docExplFrecCard,
        explRitCard: docExplRitCard,
        explFrecResp: docExplFrecResp,
        explElectr: docExplElectr,
        explPulCar: docExplPulCar,
        explPulYug: docExplPulYug,
        explLocom: docExplLocom,
        explExpRef: docExplExpRef,
        explRefPup: docExplRefPup,
        explRefRot: docExplRefRot,
        detAnali: docDetAnali,
        testOrina: docTestOrina,
        evoluc: docEvoluc,
        juiClin: docJuiClin,
        tratFarm: docTratFarm,
        recomdMed: docRecomdMed,
        recomdIng: docRecomdIng,
        analiFecha,
        analiHematiesResult,
        analiHemoglobResult,
        analiHematcrResult,
        analiVcmResult,
        analiHcmResult,
        analiChcmResult,
        analiIdhResult,
        analiLeucoResult,
        analiNeutrResult,
        analiLinfoResult,
        analiMonocResult,
        analiEosinResult,
        analiBasofResult,
        analiPlaqResult,
        analiPctResult,
        analiVpmResult,
        analiIdpResult,
        analiTieProtResult,
        analiActProtResult,
        analiInrResult,
        analiGlucResult,
        analiUreaResult,
        analiCreatResult,
        analiGlomResult,
        analiAsparResult,
        analiAlanResult,
        analiGammResult,
        analiFosfResult,
        analiBiliResult,
        analiColestResult,
        analiColestHdlResult,
        analiColestLdlResult,
        analiTriglResult,
        analiCalcResult,
        analiHierrResult,
        analiSodResult,
        analiPotasResult,
        analiVitbResult,
        analiVitohResult,
        analiAcidfolResult,
        analiMagnResult,
        analiFerriResult,
        analiProtcResult,
        analiHematiesLow,
        analiHematiesHigh,
        analiHemoglobLow,
        analiHemoglobHigh,
        analiHematcrLow,
        analiHematcrHigh,
        analiVcmLow,
        analiVcmHigh,
        analiHcmLow,
        analiHcmHigh,
        analiChcmLow,
        analiChcmHigh,
        analiIdhLow,
        analiIdhHigh,
        analiLeucoLow,
        analiLeucoHigh,
        analiNeutrLow,
        analiNeutrHigh,
        analiLinfoLow,
        analiLinfoHigh,
        analiMonocLow,
        analiMonocHigh,
        analiEosinLow,
        analiEosinHigh,
        analiBasofLow,
        analiBasofHigh,
        analiPlaqLow,
        analiPlaqHigh,
        analiPctLow,
        analiPctHigh,
        analiVpmLow,
        analiVpmHigh,
        analiIdpLow,
        analiIdpHigh,
        analiTieProtLow,
        analiTieProtHigh,
        analiActProtLow,
        analiActProtHigh,
        analiInrLow,
        analiInrHigh,
        analiGlucLow,
        analiGlucHigh,
        analiUreaLow,
        analiUreaHigh,
        analiCreatLow,
        analiCreatHigh,
        analiGlomLow,
        analiGlomHigh,
        analiAsparLow,
        analiAsparHigh,
        analiAlanLow,
        analiAlanHigh,
        analiGammLow,
        analiGammHigh,
        analiFosfLow,
        analiFosfHigh,
        analiBiliLow,
        analiBiliHigh,
        analiColestLow,
        analiColestHigh,
        analiColestHdlLow,
        analiColestHdlHigh,
        analiColestLdlLow,
        analiColestLdlHigh,
        analiTriglLow,
        analiTriglHigh,
        analiCalcLow,
        analiCalcHigh,
        analiHierrLow,
        analiHierrHigh,
        analiSodLow,
        analiSodHigh,
        analiPotasLow,
        analiPotasHigh,
        analiVitbLow,
        analiVitbHigh,
        analiVitohLow,
        analiVitohHigh,
        analiAcidfolLow,
        analiAcidfolHigh,
        analiMagnLow,
        analiMagnHigh,
        analiFerriLow,
        analiFerriHigh,
        analiProtcLow,
        analiProtcHigh,
        analiExist
      });

      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, "informe-alta.docx");
    } catch (error) {
      console.error("Error al generar el documento .docx", error);
    }
  };

  useEffect(() => {
    updateData(data);
    setShowDocxLink(true);
  }, [
    docResp,
    docColegiado,
    docFecha,
    docPacie,
    docNhc,
    docFechIngr,
    docMotivIngr,
    docObserv,
    docEnfAct,
    docExplAspect,
    docExplPiel,
    docExplNariz,
    docExplBoca,
    docExplOrof,
    docExplTronc,
    docExplExtr,
    docExplFane,
    docExplAusc,
    docExplVesi,
    docExplVent,
    docExplTASent,
    docExplFrecCard,
    docExplRitCard,
    docExplFrecResp,
    docExplElectr,
    docExplPulCar,
    docExplPulYug,
    docExplLocom,
    docExplExpRef,
    docExplRefPup,
    docExplRefRot,
    docDetAnali,
    docTestOrina,
    docEvoluc,
    docJuiClin,
    docTratFarm,
    docRecomdMed,
    docRecomdIng,
    docAnalitica
  ]);

  return (
    <>
    <div className='docFormContainer'>
      <div className="grid--2col">
        <div className='field'>
          <label htmlFor='docResp'>Responsable</label>
          <div className='control'>
            <input
              className='input'
              id='docResp'
              required
              type='text'
              value={docResp}
              onChange={(e) => setDocResp(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docColegiado'>Número de Colegiado</label>
          <div className='control'>
            <input
              className='input'
              id='docColegiado'
              required
              type='text'
              value={docColegiado}
              onChange={(e) => setDocColegiado(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docPacie'>Paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docPacie'
              required
              type='text'
              value={docPacie}
              onChange={(e) => setDocPacie(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docNhc'>NHC</label>
          <div className='control'>
            <input
              className='input'
              id='docNhc'
              required
              type='text'
              value={docNhc}
              onChange={(e) => setDocNhc(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFechIngr'>Fecha de ingreso</label>
          <div className='control'>
            <input
              className='input'
              id='docFechIngr'
              required
              type='date'
              value={docFechIngr}
              onChange={(e) => setDocFechIngr(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFecha'>Fecha de alta</label>
          <div className='control'>
            <input
              className='input'
              id='docFecha'
              required
              type='date'
              value={docFecha}
              onChange={(e) => setDocFecha(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docMotivIngr'>Motivo de ingreso</label>
          <div className='control'>
            <input
              className='input'
              id='docMotivIngr'
              required
              type='text'
              value={docMotivIngr}
              onChange={(e) => setDocMotivIngr(e.target.value)}
            />
          </div>
        </div>
        </div>
        <div className='field'>
          <label htmlFor='docObserv'>Antecedentes personales</label>
          <div className='control'>
            <textarea
              className='textarea'
              name='docObserv'
              id='docObserv'
              value={docObserv}
              onChange={(e) => setDocObserv(e.target.value)}
            ></textarea>
          </div>
        </div>
        <div className="grid--2col">
        <div className='field'>
          <label htmlFor='docEnfAct'>Enfermedad actual</label>
          <div className='control'>
            <input
              className='input'
              id='docEnfAct'
              required
              type='text'
              value={docEnfAct}
              onChange={(e) => setDocEnfAct(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplAspect'>Aspecto general</label>
          <div className='control'>
            <input
              className='input'
              id='docExplAspect'
              required
              type='text'
              value={docExplAspect}
              onChange={(e) => setDocExplAspect(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplPiel'>Piel</label>
          <div className='control'>
            <input
              className='input'
              id='docExplPiel'
              required
              type='text'
              value={docExplPiel}
              onChange={(e) => setDocExplPiel(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplNariz'>Nariz</label>
          <div className='control'>
            <input
              className='input'
              id='docExplNariz'
              required
              type='text'
              value={docExplNariz}
              onChange={(e) => setDocExplNariz(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplBoca'>Boca</label>
          <div className='control'>
            <input
              className='input'
              id='docExplBoca'
              required
              type='text'
              value={docExplBoca}
              onChange={(e) => setDocExplBoca(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplOrof'>Orofaringe</label>
          <div className='control'>
            <input
              className='input'
              id='docExplOrof'
              required
              type='text'
              value={docExplOrof}
              onChange={(e) => setDocExplOrof(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplTronc'>Tronco</label>
          <div className='control'>
            <input
              className='input'
              id='docExplTronc'
              required
              type='text'
              value={docExplTronc}
              onChange={(e) => setDocExplTronc(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplExtr'>Extremidades</label>
          <div className='control'>
            <input
              className='input'
              id='docExplExtr'
              required
              type='text'
              value={docExplExtr}
              onChange={(e) => setDocExplExtr(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplFane'>Faneras</label>
          <div className='control'>
            <input
              className='input'
              id='docExplFane'
              required
              type='text'
              value={docExplFane}
              onChange={(e) => setDocExplFane(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplAusc'>Auscultación</label>
          <div className='control'>
            <input
              className='input'
              id='docExplAusc'
              required
              type='text'
              value={docExplAusc}
              onChange={(e) => setDocExplAusc(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplVesi'>Murmullo vesicular</label>
          <div className='control'>
            <input
              className='input'
              id='docExplVesi'
              required
              type='text'
              value={docExplVesi}
              onChange={(e) => setDocExplVesi(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplVent'>Ventilación de bases</label>
          <div className='control'>
            <input
              className='input'
              id='docExplVent'
              required
              type='text'
              value={docExplVent}
              onChange={(e) => setDocExplVent(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplTASent'>TA Sentado</label>
          <div className='control'>
            <input
              className='input'
              id='docExplTASent'
              required
              type='text'
              value={docExplTASent}
              onChange={(e) => setDocExplTASent(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplFrecCard'>Frecuencia cardiaca</label>
          <div className='control'>
            <input
              className='input'
              id='docExplFrecCard'
              required
              type='text'
              value={docExplFrecCard}
              onChange={(e) => setDocExplFrecCard(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplRitCard'>Ritmo cardiaco</label>
          <div className='control'>
            <input
              className='input'
              id='docExplRitCard'
              required
              type='text'
              value={docExplRitCard}
              onChange={(e) => setDocExplRitCard(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplFrecResp'>Frecuencia respiratoria</label>
          <div className='control'>
            <input
              className='input'
              id='docExplFrecResp'
              required
              type='text'
              value={docExplFrecResp}
              onChange={(e) => setDocExplFrecResp(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplElectr'>Electrocardiograma</label>
          <div className='control'>
            <input
              className='input'
              id='docExplElectr'
              required
              type='text'
              value={docExplElectr}
              onChange={(e) => setDocExplElectr(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplPulCar'>Pulsos caritoideos</label>
          <div className='control'>
            <input
              className='input'
              id='docExplPulCar'
              required
              type='text'
              value={docExplPulCar}
              onChange={(e) => setDocExplPulCar(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplPulYug'>Pulso yugular</label>
          <div className='control'>
            <input
              className='input'
              id='docExplPulYug'
              required
              type='text'
              value={docExplPulYug}
              onChange={(e) => setDocExplPulYug(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplLocom'>Locomotor</label>
          <div className='control'>
            <input
              className='input'
              id='docExplLocom'
              required
              type='text'
              value={docExplLocom}
              onChange={(e) => setDocExplLocom(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplExpRef'>Exploración de reflejos</label>
          <div className='control'>
            <input
              className='input'
              id='docExplExpRef'
              required
              type='text'
              value={docExplExpRef}
              onChange={(e) => setDocExplExpRef(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplRefPup'>Reflejos pupilares</label>
          <div className='control'>
            <input
              className='input'
              id='docExplRefPup'
              required
              type='text'
              value={docExplRefPup}
              onChange={(e) => setDocExplRefPup(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docExplRefRot'>Reflejo rotulianos</label>
          <div className='control'>
            <input
              className='input'
              id='docExplRefRot'
              required
              type='text'
              value={docExplRefRot}
              onChange={(e) => setDocExplRefRot(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docDetAnali'>Exámenes complementarios</label>
          <div className='control'>
            <input
              className='input'
              id='docDetAnali'
              required
              type='text'
              value={docDetAnali}
              onChange={(e) => setDocDetAnali(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docTestOrina'>Test tóxicos en orina</label>
          <div className='control'>
            <input
              className='input'
              id='docTestOrina'
              required
              type='text'
              value={docTestOrina}
              onChange={(e) => setDocTestOrina(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docEvoluc'>Evolución</label>
          <div className='control'>
            <input
              className='input'
              id='docEvoluc'
              required
              type='text'
              value={docEvoluc}
              onChange={(e) => setDocEvoluc(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docJuiClin'>Impresión diagnóstica</label>
          <div className='control'>
            <input
              className='input'
              id='docJuiClin'
              required
              type='text'
              value={docJuiClin}
              onChange={(e) => setDocJuiClin(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
        <label htmlFor='docAnalitica'>Analítica a incluir</label>
        <div className='control'>
          <div className='select'>
            <select
              className='select'
              id='docAnalitica'
              name='docAnalitica'
              value={docAnalitica}
              onChange={(e) => setDocAnalitica(e.target.value)}
            >
              {/* Renderizar las opciones generadas */}
              {opcionesAnalitica}
            </select>
          </div>
        </div>
      </div>
      </div>
        <div className='field'>
          <label htmlFor='docTratFarm'>Tratamiento farmacológico</label>
          <div className='control'>
            <textarea
              className='textarea'
              id='docTratFarm'
              required
              type='text'
              value={docTratFarm}
              onChange={(e) => setDocTratFarm(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docRecomdMed'>
            RECOMENDACIONES <br></br> (NOTA: si no hay alteraciones, retirar
            este párrafo)
          </label>
          <div className='control'>
            <textarea
              className='textarea'
              id='docRecomdMed'
              required
              value={docRecomdMed}
              onChange={(e) => setDocRecomdMed(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docRecomdIng'>
            (NOTA: Dejar este párrafo en caso de pauta con Antabus. De lo
            contrario eliminar párrafo)
          </label>
          <div className='control'>
            <textarea
              className='textarea'
              id='docRecomdIng'
              required
              value={docRecomdIng}
              onChange={(e) => setDocRecomdIng(e.target.value)}
            />
          </div>
        </div>

      <div className='btn-dwnld'>
        

        {showDocxLink && (
          <a className='button is-link' href='#!' onClick={generateDocx}>
            Descargar DOCX
          </a>
        )}
      </div>
    </div>

      
    </>
  );
}


